// extracted by mini-css-extract-plugin
module.exports = {"container":"CanvasCopilotIndicator_container__OlcA7","inFocusMode":"CanvasCopilotIndicator_inFocusMode__k_Ip9"};